import normalize_query from '../../util_components/search_combobox/normalize_query';

export interface AccessRole {
  access_type: string;
  user_count?: number;
  pages?: string[] | null;
}

export interface RoleRow<R extends AccessRole> {
  role: R;
  // Chips to display; the full list stays on `role.pages`.
  pages: string[];
  hidden_count: number;
}

export const role_key = (r: AccessRole): string => r.access_type;

// `query` must already be trimmed and lower-cased; empty matches every role.
export const role_matches = (r: AccessRole, query: string): boolean =>
  !query || r.access_type.toLowerCase().includes(query);

// `role` is an exact access_type ('' = all); `page_query` is a raw case-insensitive substring.
export const filter_roles = <R extends AccessRole>(
  roles: R[],
  role: string,
  page_query: string
): RoleRow<R>[] => {
  const q = normalize_query(page_query);
  const rows: RoleRow<R>[] = [];
  roles.forEach((r) => {
    if (role && r.access_type !== role) return;
    const all = r.pages || [];
    if (!q) {
      rows.push({ role: r, pages: all, hidden_count: 0 });
      return;
    }
    const pages = all.filter((p) => p.toLowerCase().includes(q));
    if (pages.length) rows.push({ role: r, pages, hidden_count: all.length - pages.length });
  });
  return rows;
};
